import React from 'react';
import {ThemeProvider, withStyles} from '@material-ui/core/styles';
import { BrowserRouter as Router,Route, Switch, Redirect } from 'react-router-dom';
import axios from 'axios';
import {connect, setStore} from 'trim-redux'
import {defaultVariabls, generateURLs} from './config';
import Login from "./class/pages/Authentication/Login";
import Loader from "./class/components/elements/Loader";
import {RTL, theme} from './config/design/theme';
import {Styles} from "./config/design/styles";
import {SnackbarProvider} from "notistack";
import PrivateRoute from "./class/components/elements/PrivateRoute";
import Layout from "./class/components/layouts/layout";
import Error404 from './class/pages/errors/404';
import FileManagerPage from "./class/pages/fileManager/FileManagerPage";
import MobileVerify from "./class/pages/Authentication/MobileVerify";
import ChangePassword from "./class/pages/user/ChangePassword";
import ForgetPassword from "./class/pages/Authentication/ForgetPassword";
import LoginWithToken from "./class/pages/Authentication/LoginWithToken";
import Register from "./class/pages/Authentication/Register";
import VerifyEmailPage from "./class/pages/Authentication/VerifyEmailPage";
import Permission from "./class/components/elements/Permission";
import {ErrorBoundary} from 'react-error-boundary'
import IconButton from "@material-ui/core/IconButton/IconButton";
import CachedRoundedIcon from '@material-ui/icons/CachedRounded';
import Snackbar from "@material-ui/core/Snackbar/Snackbar";
import {Translate} from "./config/Translate";
import MakeContent from "./class/pages/contents/MakeContent";
import UserDetails from "./class/pages/user/UserDetails";
import MakeShopPage from "./class/pages/shop/MakeShopPage";
import ShopsPage from "./class/pages/shop/ShopsPage";
import MakeProduct from "./class/pages/products/MakeProduct";
import CategoriesPage from "./class/pages/admin/categories/CategoriesPage";
import MakeCategory from "./class/pages/admin/categories/MakeCategory";
import ProductsPage from "./class/pages/products/ProductsPage";
import CommentsPage from "./class/pages/admin/comments/CommentsPage";
import ManageAbout from "./class/pages/admin/pages/ManageAbout";
import ManageTerms from "./class/pages/admin/pages/ManageTerms";
import UsersPage from "./class/pages/admin/users/UsersPage";
import ActivityLog from "./class/pages/admin/users/UsersLogPage";
import AddUserPage from "./class/pages/admin/users/AddUserPage";
import WalletPage from "./class/pages/wallet/WalletPage";
import Verification from "./class/pages/user/components/Verification";
import WalletsPage from "./class/pages/admin/wallets/WalletsPage";
import WalletHistoryPage from "./class/pages/admin/wallets/WalletHistoryPage";
import ManageVerificationsPage from "./class/pages/admin/users/ManageVerificationsPage";
import ManageOrdersPage from "./class/pages/admin/orders/ManageOrdersPage";
import MakeVariable from "./class/pages/admin/variables/MakeVariable";
import VariablesPage from "./class/pages/admin/variables/VariablesPage";
import ManageUserPage from "./class/pages/admin/users/ManageUserPage";
import MyAddressesPage from "./class/pages/user/address/MyAddressesPage";
import AttributesPage from "./class/pages/admin/attributes/AttributesPage";
import MakeValues from "./class/pages/admin/attributes/MakeValues";
import PricingPage from "./class/pages/pricing/PricingPage";
import MakePricing from "./class/pages/pricing/MakePricing";
import ModifyPricingPage from "./class/pages/pricing/ModifyPricingPage";
import BrandsPage from "./class/pages/admin/brands/BrandsPage";
import MakeBrand from "./class/pages/admin/brands/MakeBrand";
import ManagePrivacyPolicy from "./class/pages/admin/pages/ManagePrivacyPolicy";
import ManageSellerTerms from "./class/pages/admin/pages/ManageSellerTerms";
import Wishlist from "./class/pages/user/wishlist/Wishlist";
import SlideShowsPage from "./class/pages/admin/settings/slideshows/SlideShowsPage";
import BannersPage from "./class/pages/admin/settings/banners/BannersPage";
import DiscountsPage from "./class/pages/admin/discounts/DiscountsPage";
import MakeDiscount from "./class/pages/admin/discounts/MakeDiscount";
import CheckoutPage from "./class/pages/checkout/CheckoutPage";
import CreateOrder from "./class/pages/checkout/CreateOrder";
import SiteSettingsPage from "./class/pages/admin/settings/siteSettings/SiteSettingsPage";
import UserOrdersPage from "./class/pages/orders/user_orders/UserOrdersPage";
import ViewOrder from "./class/pages/orders/user_orders/ViewOrder";
import ManageOrder from "./class/pages/admin/orders/ManageOrder";
import Role from "./class/components/elements/Role";
import ShopOrdersPage from "./class/pages/orders/shop_orders/ShopOrdersPage";
import CheckOrder from "./class/pages/orders/shop_orders/CheckOrder";
import SyncAuth from "./class/pages/Authentication/SyncAuth";
import ShopCommentsPage from "./class/pages/admin/shop-comments/ShopCommentsPage";
import AdminDashboard from "./class/pages/admin/analytics/AdminDashboard";
import SellerDashboard from "./class/pages/Dashboard/SellerDashboard";
import OrdersAnalyticsPage from "./class/pages/admin/analytics/OrdersAnalyticsPage";
import ManageContact from "./class/pages/admin/pages/ManagePage";
import UserDashboard from "./class/pages/Dashboard/UserDashboard";
import RedirectsPage from "./class/pages/admin/settings/redirects/RedirectsPage";
import ManageViolations from "./class/pages/admin/pages/ManageViolations";
import TicketsPage from "./class/pages/tickets/TicketsPage";
import Ticket from "./class/pages/tickets/Ticket/index";
import DepartmentsPage from "./class/pages/tickets/departments/DepartmentsPage";
import AgentsPage from "./class/pages/admin/users/agents/AgentsPage";
import ManageAgentPage from "./class/pages/admin/users/agents/ManageAgentPage";
import AgentDashboard from "./class/pages/Dashboard/AgentDashboard";
import AgentOrdersPage from "./class/pages/admin/users/agents/AgentOrdersPage";
import TransferPricingPage from "./class/pages/admin/settings/transfer_pricing/TransferPricingPage";
import ManageAgentTerms from "./class/pages/admin/pages/ManageAgentTerms";
import Feature from "./class/components/elements/Feature";
import ContentsPage from "./class/pages/contents/ContentsPage";
import BlogCategoriesPage from "./class/pages/admin/blog_categories/BlogCategoriesPage";
import MakeBlogCategory from "./class/pages/admin/blog_categories/MakeBlogCategory";
import BlogCommentsPage from "./class/pages/admin/blog-comments/BlogCommentsPage";
import MakePage from "./class/pages/admin/pages/MakePage";
import PagesPage from "./class/pages/admin/pages/PagesPage";
import ManageTemplateWithoutDrag from "./class/pages/admin/template/ManageTemplateWithoutDrag";
import SiteInformationPage from "./class/pages/admin/settings/siteSettings/SiteInformationPage";
import ContactInformationPage from "./class/pages/admin/settings/siteSettings/contact/ContactInformationPage";
import CustomCode from "./class/pages/admin/settings/siteSettings/CustomCode";
import HeaderAndFooter from "./class/pages/admin/template/HeaderAndFooter";
import MyShopPage from "./class/pages/shop/MyShopPage";
import WritersPage from "./class/pages/admin/writers/WritersPage";
import MakeWriter from "./class/pages/admin/writers/MakeWriter";
import TranslatorsPage from "./class/pages/admin/translators/TranslatorsPage";
import MakeTranslator from "./class/pages/admin/translators/MakeTranslator";
import LabelsPage from "./class/pages/admin/labels/LabelsPage";
import MakeLabel from "./class/pages/admin/labels/MakeLabel";
import MakeReview from "./class/pages/reviews/MakeReview";
import ReviewPage from "./class/pages/reviews/ReviewPage";
import ManageReview from "./class/pages/reviews/ManageReview";
import MakeRevision from "./class/pages/revision/MakeRevision";
import RevisionsPage from "./class/pages/revision/RevisionsPage";
import EditRevision from "./class/pages/revision/EditRevision";
import Typography from "@material-ui/core/Typography/Typography";
import RequestSupplierPage from "./class/pages/shop/RequestSupplierPage";
import CommissionsPage from "./class/pages/admin/settings/siteSettings/commissions/CommissionsPage";
import ShopDiscountsPage from "./class/pages/shop/shop_discounts/ShopDiscountsPage";
import MakeShopDiscount from "./class/pages/shop/shop_discounts/MakeShopDiscount";
import FestivalsPage from "./class/pages/admin/festivals/FestivalsPage";
import MakeFestival from "./class/pages/admin/festivals/MakeFestival";
import ViewFestivals from "./class/pages/shop/festivals/ViewFestivals";
import PackagesPage from "./class/pages/admin/packages/PackagesPage";
import MakePackage from "./class/pages/admin/packages/MakePackage";
import BuyPackage from "./class/pages/package/BuyPackage";
import BuyPackagePage from "./class/pages/package/BuyPackagePage";
import ManagePackagesOrdersPage from "./class/pages/admin/packages/ManagePackagesOrdersPage";
import ManageTransferPricingPage from "./class/pages/admin/settings/transfer_pricing/ManageTransferPricingPage";
import Logout from "./class/pages/Authentication/Logout";
import WalletsRequestsPage from "./class/pages/admin/wallets/WalletsRequestsPage";
import NarratorsPage from "./class/pages/admin/narrators/NarratorsPage";
import MakeNarrator from "./class/pages/admin/narrators/MakeNarrator";
class App extends React.Component{
    state ={
        loading:true,
    };
    async componentDidMount(){
        await generateURLs();
        await this.loadData();

        if(this.props.isAuth){
            await this.loadUserSetting();
        }else{
            await this.loadSetting();
        }
    }
    async loadSetting(){
        let config = {
            headers: {
                Accept: 'application/json',
            }
        };
        await axios.get(`${defaultVariabls.url}/settings/get_all`, config)
            .then(response => {
                setStore({
                    setting:response.data,
                    primary_color:response.data.primary_color,
                    secondary_color:response.data.secondary_color,
                    logo:response.data.site_logo,
                    app_name:response.data.app_name,
                    x_price:response.data.x_price,
                    primary_shop:response.data.primary_shop,
                    global_need_verification:parseInt(response.data.global_need_verification),
                    admins:response.data.admins,
                    menu:response.data.menu,
                    about:response.data.about,
                    features:response.data.features,
                });
                this.setState({
                    loading:false,
                })
            }).catch(error => {
                console.log(error)
            })
    }
    async loadUserSetting(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`

            }
        };
        await axios.get(`${defaultVariabls.url}/settings/get_all_for_user`, config)
            .then(response => {
                setStore({
                    setting:response.data,
                    primary_color:response.data.primary_color,
                    secondary_color:response.data.secondary_color,
                    logo:response.data.site_logo,
                    app_name:response.data.app_name,
                    x_price:response.data.x_price,
                    primary_shop:response.data.primary_shop,
                    global_need_verification:parseInt(response.data.global_need_verification),
                    admins:response.data.admins,
                    menu:response.data.menu,
                    about:response.data.about,
                    features:response.data.features,
                });
                this.setState({
                    loading:false,
                })
            }).catch(error => {
                console.log(error.response)
            })
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/checkLogin`, config)
                .then(response => {
                    setStore({
                        isAuth : true,
                        user : response.data,
                    });
                    if(response.data.mobile_confirmed === 1){
                        let redirect = localStorage.getItem('redirect');
                        if(!!redirect){
                            localStorage.removeItem('redirect');
                            this.props.history.push(redirect);
                        }
                        let external_redirect = localStorage.getItem('external_redirect');
                        if(!!external_redirect){
                            localStorage.removeItem('external_redirect');
                            window.location.replace(external_redirect);
                        }
                    }
                }).catch(error => {
                    console.log(error.response)
                    setStore({
                        isAuth : false,
                        user : null,
                    });
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                loading:false
            })
        }
    }

    ErrorFallback({error}) {
        if(!!error){
            return (
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    open={true}
                    message={Translate.errorHappens}
                    action={
                        <React.Fragment>
                            <IconButton  onClick={() => window.location.reload()}>
                                <CachedRoundedIcon color="secondary"/>
                            </IconButton>
                        </React.Fragment>
                    }
                />
            )
        }

    }
    classes = this.props.classes;
    render(){
        let {user,global_loading} = this.props;
        if(this.state.loading){
            return(
                <Loader/>
            )
        }else{
            return(
                <ThemeProvider theme={theme}>
                    <SnackbarProvider anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}>
                        <RTL>
                            <ErrorBoundary FallbackComponent={this.ErrorFallback}>
                                <Router>
                                    <Switch>
                                        <Redirect exact from='/' to='/dashboard'/>
                                        <Route  path="/notingFound" >
                                            <Error404/>
                                        </Route>
                                        {/*Auth Routes*/}
                                        <Route path="/login">
                                            <Login />
                                        </Route>
                                        <Route path="/sync-auth">
                                            <SyncAuth />
                                        </Route>
                                        <Route exact path="/register">
                                            <Register />
                                        </Route>
                                        <Route exact path="/verifyEmail/:id/:code">
                                            <VerifyEmailPage />
                                        </Route>
                                        <Route path="/token-login">
                                            <LoginWithToken />
                                        </Route>
                                        <Route path="/forget">
                                            <ForgetPassword />
                                        </Route>
                                        <Route path="/logout">
                                            <Logout />
                                        </Route>

                                        <PrivateRoute path="/verify-mobile">
                                            <MobileVerify />
                                        </PrivateRoute>

                                        <Layout>
                                            <PrivateRoute exact path="/dashboard">
                                                {
                                                    !!user ? user.role.type === 'admin' ? <AdminDashboard/> : user.role.name === 'user' ? <UserDashboard/> :  <SellerDashboard/> : null
                                                }
                                            </PrivateRoute>
                                            <Feature check="tickets">
                                                <PrivateRoute path="/tickets">
                                                    <TicketsPage />
                                                </PrivateRoute>
                                                <PrivateRoute path="/ticket/:id">
                                                    <Ticket/>
                                                </PrivateRoute>
                                                <Permission rule="manageSettings">

                                                    <PrivateRoute path="/manage/departments">
                                                        <DepartmentsPage />
                                                    </PrivateRoute>
                                                    <PrivateRoute path="/manage/tickets">
                                                        <TicketsPage manage />
                                                    </PrivateRoute>
                                                    <PrivateRoute path="/manage/ticket/:id">
                                                        <Ticket manage/>
                                                    </PrivateRoute>
                                                </Permission>
                                            </Feature>
                                            <Permission rule="fileManagerPage">
                                                <PrivateRoute path="/file-manager">
                                                    <FileManagerPage/>
                                                </PrivateRoute>
                                            </Permission>
                                            <PrivateRoute path="/account/password">
                                                <ChangePassword/>
                                            </PrivateRoute>
                                            <Feature check="wishlist">
                                                <PrivateRoute path="/wishlist">
                                                    <Wishlist/>
                                                </PrivateRoute>
                                            </Feature>
                                            <PrivateRoute path="/account/details">
                                                <UserDetails/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/account/address">
                                                <MyAddressesPage/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/account/verification">
                                                <Verification/>
                                            </PrivateRoute>
                                            <Feature check="wallet">
                                                <PrivateRoute exact path="/wallet/view">
                                                    <WalletPage/>
                                                </PrivateRoute>
                                            </Feature>
                                            <PrivateRoute exact path="/checkout">
                                                <CheckoutPage/>
                                            </PrivateRoute>
                                            <PrivateRoute exact path="/order">
                                                <CreateOrder/>
                                            </PrivateRoute>
                                            <Permission rule="manageSettings">
                                                <PrivateRoute exact path="/manage/reviews">
                                                    <ReviewPage/>
                                                </PrivateRoute>
                                                <PrivateRoute path="/review/manage/:id" exact>
                                                    <ManageReview/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/comments">
                                                    <CommentsPage/>
                                                </PrivateRoute>
                                                <Feature check="review_for_shop">
                                                    <PrivateRoute exact path="/manage/shop-comments">
                                                        <ShopCommentsPage/>
                                                    </PrivateRoute>
                                                </Feature>
                                                <PrivateRoute exact path="/manage/pages/about">
                                                    <ManageAbout/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/contacts">
                                                    <ManageContact/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/violations">
                                                    <ManageViolations/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/pages/terms">
                                                    <ManageTerms/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/pages/privacy-policy">
                                                    <ManagePrivacyPolicy/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/pages/seller-terms">
                                                    <ManageSellerTerms/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/pages/agent-terms">
                                                    <ManageAgentTerms/>
                                                </PrivateRoute>
                                                <PrivateRoute path="/setting/contact">
                                                    <ContactInformationPage/>
                                                </PrivateRoute>
                                                <PrivateRoute path="/setting/commissions">
                                                    <CommissionsPage/>
                                                </PrivateRoute>
                                                <PrivateRoute path="/setting/custom-code">
                                                    <CustomCode />
                                                </PrivateRoute>
                                                <PrivateRoute path="/setting/header-footer">
                                                    <HeaderAndFooter />
                                                </PrivateRoute>
                                                <PrivateRoute path="/setting/information">
                                                    <SiteInformationPage/>
                                                </PrivateRoute>
                                                {/*<PrivateRoute exact path="/settings/translate-front">
                                                    <TranslateFront/>
                                                </PrivateRoute>*/}
                                                <PrivateRoute exact path="/settings/slideshows">
                                                    <SlideShowsPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/settings/banners">
                                                    <BannersPage/>
                                                </PrivateRoute>
                                                <Feature check="redirects">
                                                <PrivateRoute exact path="/settings/redirects">
                                                    <RedirectsPage/>
                                                </PrivateRoute>
                                                </Feature>
                                                <PrivateRoute exact path="/manage/template">
                                                    <ManageTemplateWithoutDrag/>
                                                </PrivateRoute>
                                                <Feature check="agent">
                                                <PrivateRoute exact path="/manage/agents">
                                                    <AgentsPage/>
                                                </PrivateRoute>
                                                </Feature>
                                                <PrivateRoute exact path="/manage/users/view/:role?">
                                                    <UsersPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/users/add">
                                                    <AddUserPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/user/:id">
                                                    <ManageUserPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/agent/:id">
                                                    <ManageAgentPage/>
                                                </PrivateRoute>
                                                <Feature check="activity_log">
                                                    <PrivateRoute exact path="/manage/activities/:query?">
                                                        <ActivityLog/>
                                                    </PrivateRoute>
                                                </Feature>
                                                <PrivateRoute exact path="/analytics/orders">
                                                    <OrdersAnalyticsPage/>
                                                </PrivateRoute>
                                            </Permission>
                                            <Permission rule="manageShops">
                                                <Feature check="marketplace">
                                                    <PrivateRoute exact path="/manage/shops">
                                                        <ShopsPage/>
                                                    </PrivateRoute>
                                                </Feature>
                                                <PrivateRoute exact path="/manage/products">
                                                    <ProductsPage manage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/revisions">
                                                    <RevisionsPage manage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/edit/revision/:id">
                                                    <EditRevision manage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/orders">
                                                    <ManageOrdersPage manage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/transfer-price">
                                                    <ManageTransferPricingPage manage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/packages-orders">
                                                    <ManagePackagesOrdersPage manage/>
                                                </PrivateRoute>
                                                <PrivateRoute path="/order/manage/:id">
                                                    <ManageOrder/>
                                                </PrivateRoute>
                                                <PrivateRoute path="/manage/pricing/:type" exact>
                                                    <ModifyPricingPage manage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/categories">
                                                    <CategoriesPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/create/category">
                                                    <MakeCategory new/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/edit/category/:id">
                                                    <MakeCategory />
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/pages">
                                                    <PagesPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/create/page">
                                                    <MakePage new/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/edit/page/:id">
                                                    <MakePage  />
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/packages">
                                                    <PackagesPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/edit/package/:id">
                                                    <MakePackage />
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/create/package">
                                                    <MakePackage new/>
                                                </PrivateRoute>
                                                <Feature check="brands">
                                                    <PrivateRoute exact path="/manage/brands">
                                                        <BrandsPage/>
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/edit/brand/:id">
                                                        <MakeBrand />
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/create/brand">
                                                        <MakeBrand new/>
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/manage/writers">
                                                        <WritersPage/>
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/edit/writer/:id">
                                                        <MakeWriter />
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/create/writer">
                                                        <MakeWriter new/>
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/manage/narrators">
                                                        <NarratorsPage/>
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/edit/narrator/:id">
                                                        <MakeNarrator />
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/create/narrator">
                                                        <MakeNarrator new/>
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/manage/translators">
                                                        <TranslatorsPage/>
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/edit/translator/:id">
                                                        <MakeTranslator />
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/create/translator">
                                                        <MakeTranslator new/>
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/manage/labels">
                                                        <LabelsPage/>
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/edit/label/:id">
                                                        <MakeLabel />
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/create/label">
                                                        <MakeLabel new/>
                                                    </PrivateRoute>
                                                </Feature>
                                                <PrivateRoute exact path="/manage/variables">
                                                    <VariablesPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/create/variable">
                                                    <MakeVariable new/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/edit/variable/:id">
                                                    <MakeVariable />
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/attributes">
                                                    <AttributesPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/attribute/:id">
                                                    <MakeValues/>
                                                </PrivateRoute>
                                            </Permission>
                                            <Permission rule="manageOrders">
                                                <PrivateRoute exact path="/manage/discounts">
                                                    <DiscountsPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/create/discount">
                                                    <MakeDiscount new/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/edit/discount/:id">
                                                    <MakeDiscount />
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/festivals">
                                                    <FestivalsPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/create/festival">
                                                    <MakeFestival new/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/edit/festival/:id">
                                                    <MakeFestival />
                                                </PrivateRoute>
                                            </Permission>
                                            <Permission rule="managePayments">
                                                <Feature check="wallet">
                                                    <PrivateRoute exact path="/manage/wallets">
                                                        <WalletsPage/>
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/manage/wallets-requests">
                                                        <WalletsRequestsPage/>
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/manage/wallet/:id">
                                                        <WalletHistoryPage/>
                                                    </PrivateRoute>
                                                    <PrivateRoute exact path="/manage/verifications">
                                                        <ManageVerificationsPage/>
                                                    </PrivateRoute>
                                                </Feature>
                                            </Permission>
                                            <PrivateRoute path="/create/shop">
                                                <MakeShopPage/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/edit/shop/:id">
                                                <MakeShopPage edit/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/my-shops">
                                                <ShopsPage myShops/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/my-shop">
                                                <MyShopPage myShops/>
                                            </PrivateRoute>
                                            <PrivateRoute exact path="/vendor/discounts">
                                                <ShopDiscountsPage/>
                                            </PrivateRoute>
                                            <PrivateRoute exact path="/vendor/create/discount">
                                                <MakeShopDiscount new/>
                                            </PrivateRoute>
                                            <PrivateRoute exact path="/vendor/edit/discount/:id">
                                                <MakeShopDiscount />
                                            </PrivateRoute>
                                            <PrivateRoute exact path="/festivals">
                                                <ViewFestivals/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/request/supplier">
                                                <RequestSupplierPage/>
                                            </PrivateRoute>
                                            <Feature check="blog">
                                                <PrivateRoute exact path="/manage/blog-categories">
                                                    <BlogCategoriesPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/manage/blog-comments">
                                                    <BlogCommentsPage/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/create/blog-category">
                                                    <MakeBlogCategory new/>
                                                </PrivateRoute>
                                                <PrivateRoute exact path="/edit/blog-category/:id">
                                                    <MakeBlogCategory />
                                                </PrivateRoute>
                                                <PrivateRoute path="/manage/contents" exact>
                                                    <ContentsPage/>
                                                </PrivateRoute>
                                                <PrivateRoute path="/create/content" exact>
                                                    <MakeContent new/>
                                                </PrivateRoute>
                                                <PrivateRoute path="/edit/content/:id">
                                                    <MakeContent />
                                                </PrivateRoute>
                                            </Feature>
                                            <PrivateRoute path="/pricing" exact>
                                                <PricingPage/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/modify-pricing" exact>
                                                <ModifyPricingPage/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/pricing/product/:id" exact>
                                                <MakePricing/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/transfer-pricing" exact>
                                                <TransferPricingPage/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/my-products" exact>
                                                <ProductsPage/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/buy-package" exact>
                                                <BuyPackagePage/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/create/product" exact>
                                                <MakeProduct new/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/edit/product/:id">
                                                <MakeProduct />
                                            </PrivateRoute>
                                            <PrivateRoute path="/revision/product/:id">
                                                <MakeRevision new/>
                                            </PrivateRoute>
                                            <PrivateRoute path="/my-orders">
                                                <UserOrdersPage />
                                            </PrivateRoute>
                                            <PrivateRoute path="/review/product/:id" exact>
                                                <MakeReview new/>
                                            </PrivateRoute>
                                            <Feature check="agent">
                                                <PrivateRoute path="/agent">
                                                    <AgentOrdersPage />
                                                </PrivateRoute>
                                            </Feature>
                                            <PrivateRoute path="/order/view/:id">
                                                <ViewOrder/>
                                            </PrivateRoute>
                                            <Feature check="marketplace">
                                                <Role role="supplier" type="normal">
                                                    <PrivateRoute path="/shop-orders">
                                                        <ShopOrdersPage />
                                                    </PrivateRoute>
                                                    <PrivateRoute path="/order/check/:id">
                                                        <CheckOrder/>
                                                    </PrivateRoute>
                                                </Role>
                                                <Role type="admin">
                                                    <PrivateRoute path="/shop-orders">
                                                        <ShopOrdersPage />
                                                    </PrivateRoute>
                                                    <PrivateRoute path="/order/check/:id">
                                                        <CheckOrder/>
                                                    </PrivateRoute>
                                                </Role>
                                            </Feature>
                                            <Route  path="/404" >
                                                <Error404/>
                                            </Route>
                                        </Layout>
                                        {/*Errors Routes*/}
                                        <Route path="*" component={Error404} status={404}/>
                                    </Switch>
                                </Router>
                            </ErrorBoundary>
                        </RTL>
                    </SnackbarProvider>
                </ThemeProvider>
            )
        }

    }

}
const mstp = state => ({
    user: state.user,
    isAuth:state.isAuth,
    global_loading:state.global_loading
});
export default withStyles(Styles)(connect(mstp)(App));
